import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { selectMainCategories } from '../routing/fetchingfunction/user/user.reducer'
import { getMainCategories } from '../routing/fetchingfunction/user/user.action'

const useMainCategories = () => {
  const dispatch = useDispatch()

  const mainCategories = useSelector(selectMainCategories)

  useEffect(() => {
    if (!mainCategories.length) {
      dispatch(getMainCategories())
    }
  }, [])

  return mainCategories
}

export default useMainCategories
